import { render, staticRenderFns } from "./MedicalPage.vue?vue&type=template&id=43fb05a1&scoped=true&"
import script from "./MedicalPage.vue?vue&type=script&lang=js&"
export * from "./MedicalPage.vue?vue&type=script&lang=js&"
import style0 from "./MedicalPage.vue?vue&type=style&index=0&id=43fb05a1&scoped=true&lang=css&"
import style1 from "./MedicalPage.vue?vue&type=style&index=1&lang=sass&"
import style2 from "./MedicalPage.vue?vue&type=style&index=2&id=43fb05a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43fb05a1",
  null
  
)

export default component.exports
import {QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QBanner,QTable,QTr,QTh,QTd,QImg,QAvatar,QCard,QCardSection,QSpinnerPuff,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QBtn,QBtnDropdown,QList,QItem,QItemSection,QItemLabel,QIcon,QDialog,QBanner,QTable,QTr,QTh,QTd,QImg,QAvatar,QCard,QCardSection,QSpinnerPuff,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
